"use strict";
var __extends = (this && this.__extends) || function (d, b) {
    for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p];
    function __() { this.constructor = d; }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
};
var baseComponent_1 = require("./base/baseComponent");
var ko = require("knockout");
var $ = require("jquery");
var _ = require("lodash");
var ajaxUtils_1 = require("../../app/utils/ajaxUtils");
var tippy = require('tippy.js').default;
var MobileMarkButtonComponent = (function (_super) {
    __extends(MobileMarkButtonComponent, _super);
    function MobileMarkButtonComponent(params, element, templateNodes) {
        var _this = this;
        _super.call(this, params, element, templateNodes);
        this.defaultBtnTitle = "Реакции";
        this.animationTime = 1920 * 2;
        this.$markPopover = $("#markPopover");
        this.backHistoryAfterClose = true;
        this.workMarks = ko.observableArray();
        this.isDisabled = ko.observable(false);
        this.disabledBtnTitle = ko.observable();
        this.activeMark = ko.pureComputed(function () {
            return _.find(_this.allMarks, function (m) { return m.enumValue === _this.workMarks()[0]; });
        });
        this.titleBtn = ko.pureComputed(function () {
            if (_this.isDisabled() && _this.disabledBtnTitle()) {
                return _this.disabledBtnTitle();
            }
            if (_this.activeMark()) {
                return _this.activeMark().title;
            }
            else {
                return _this.defaultBtnTitle;
            }
        });
        this.activeMarkSrc = ko.pureComputed(function () {
            if (_this.activeMark()) {
                return app.rootUrl + "distCommon/emoji/" + _this.activeMark().code + ".svg";
            }
            else {
                return '';
            }
        });
        this.activeMarkAlt = ko.pureComputed(function () {
            if (_this.activeMark()) {
                return "&#x" + _this.activeMark().code;
            }
            else {
                return '';
            }
        });
        this.isLoading = ko.observable(false);
        this.preparePopover = function () {
            var popover = $("#markPopover")[0];
            if (popover) {
                ko.cleanNode(popover);
                ko.applyBindingsToDescendants(_this, popover);
                window.history && window.history.pushState("forward", null, "");
                _this.backHistoryAfterClose = true;
                _this.$markPopover.one('popover:closed', function () {
                    if (_this.backHistoryAfterClose) {
                        window.history && window.history.back();
                    }
                });
            }
        };
        this.toggleMark = function (mark, viewModel, event) {
            if (_this.isLoading())
                return;
            _this.isLoading(true);
            var isActive = _this.workMarks().indexOf(mark) === -1;
            //var $img = $(event.target);
            //if (isActive) {
            //    $img.attr("src", $img.attr("data-animated-src"));
            //    setTimeout(() => {
            //            $img.attr("src", $img.attr("data-src"));
            //    }, this.animationTime);
            //}
            ajaxUtils_1.AjaxUtils.post("work/mark", {
                workId: _this.workId,
                isActive: isActive,
                mark: mark
            }).done(function (result) {
                if (!result.isSuccessful) {
                    alert(result.messages[0]);
                    return;
                }
                _this.workMarks(result.data.marks);
            }).always(function () {
                _this.isLoading(false);
                _this.handleRefreshWorkMetaInfo(app, _this.workId);
            });
        };
        this.workId = params.workId;
        this.allMarks = params.allMarks;
        this.workMarks(params.workMarks || []);
        this.isDisabled(params.disabled || false);
        this.disabledBtnTitle(params.disabledBtnTitle);
        if (!this.$markPopover.data('isTippyInit')) {
            this.$markPopover.data('isTippyInit', true);
            var tippyEls = this.isDisabled() ? ".mark-dropdown" : this.$markPopover.find("button").toArray();
            setTimeout(function () {
                tippy(tippyEls, {
                    content: function (c) { return c.getAttribute('data-hint') || c.getAttribute('title'); },
                    trigger: 'click',
                    animation: 'scale',
                    allowHTML: true,
                    interactive: _this.isDisabled(),
                    onShow: function (el) {
                        setTimeout(function () {
                            el.hide();
                        }, _this.animationTime / 2);
                    },
                    zIndex: 14000
                });
            }, 0);
        }
        $(window).on("popstate", function () {
            _this.backHistoryAfterClose = false;
            _this.closeMarkPopover();
        });
    }
    MobileMarkButtonComponent.prototype.closeMarkPopover = function () {
        this.$markPopover.hasClass("modal-in") && app.f7.closeModal(this.$markPopover[0]);
    };
    return MobileMarkButtonComponent;
}(baseComponent_1.default));
ko.components.register("mobile-mark-button", {});
Object.defineProperty(exports, "__esModule", { value: true });
exports.default = MobileMarkButtonComponent;
//# sourceMappingURL=mobileMarkButton.js.map